import { InjectionToken } from "@angular/core";
import { IReceiverQuickAccessMenuStateService } from "./i-receiver-quick-access-menu-state.service";

export const receiverQuickAccessMenuStateServiceInjectionToken: InjectionToken<IReceiverQuickAccessMenuStateService> = new InjectionToken<IReceiverQuickAccessMenuStateService>("digital-signage.user-dashboard.dashboard-web.CloudQuickAccessMenuStateService");
